"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.VxTestAppCheckError = exports.LinuxNotSupportedError = exports.V3NodeNotSupportedError = exports.NodeNotLtsError = exports.NodeNotFoundError = exports.DepsCheckerError = void 0;
class DepsCheckerError extends Error {
    constructor(message, helpLink) {
        super(message);
        this.helpLink = helpLink;
        Object.setPrototypeOf(this, DepsCheckerError.prototype);
    }
}
exports.DepsCheckerError = DepsCheckerError;
class NodeNotFoundError extends DepsCheckerError {
    constructor(message, helpLink) {
        super(message, helpLink);
        Object.setPrototypeOf(this, NodeNotFoundError.prototype);
    }
}
exports.NodeNotFoundError = NodeNotFoundError;
class NodeNotLtsError extends DepsCheckerError {
    constructor(message, helpLink) {
        super(message, helpLink);
        Object.setPrototypeOf(this, NodeNotLtsError.prototype);
    }
}
exports.NodeNotLtsError = NodeNotLtsError;
class V3NodeNotSupportedError extends DepsCheckerError {
    constructor(message, helpLink) {
        super(message, helpLink);
        Object.setPrototypeOf(this, V3NodeNotSupportedError.prototype);
    }
}
exports.V3NodeNotSupportedError = V3NodeNotSupportedError;
class LinuxNotSupportedError extends DepsCheckerError {
    constructor(message, helpLink) {
        super(message, helpLink);
        Object.setPrototypeOf(this, LinuxNotSupportedError.prototype);
    }
}
exports.LinuxNotSupportedError = LinuxNotSupportedError;
class VxTestAppCheckError extends DepsCheckerError {
    constructor(message, helpLink) {
        super(message, helpLink);
        Object.setPrototypeOf(this, VxTestAppCheckError.prototype);
    }
}
exports.VxTestAppCheckError = VxTestAppCheckError;
//# sourceMappingURL=depsError.js.map